var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Map, Marker, TileLayer, ZoomControl } from 'react-leaflet';
import HeaderTextDivider from '../header-text-divider';
import L from 'leaflet';
import { ProjectType } from '..';
import { loadCssDesign } from '../utils/Utils';
var QRCode = require('qrcode.react');
var Accomodation = function (_a) {
    var json_data = _a.json_data, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, getTranslation = _a.getTranslation, requestGet = _a.requestGet, RESPONSE = _a.RESPONSE, CONSTANTS_REQ = _a.CONSTANTS_REQ, projectId = _a.projectId, projectInfo = _a.projectInfo, webPageId = _a.webPageId, geti18nText = _a.geti18nText, _b = _a.projectType, projectType = _b === void 0 ? 'kiosk' : _b, css_id = _a.css_id, css_json = _a.css_json;
    var _c = useState(JSON.parse(json_data)), jsonData = _c[0], setJsonData = _c[1];
    var selLang = getSelectedClientLanguage();
    var _d = useState(45.84), lat = _d[0], setLat = _d[1];
    var _e = useState(15.9), lng = _e[0], setLng = _e[1];
    var _f = useState(9), zoom = _f[0], setZoom = _f[1];
    var _g = useState(''), webPageQRUrl = _g[0], setWebPageQRUrl = _g[1];
    var _h = useState(''), stLabel = _h[0], setStLabel = _h[1];
    var setLang = getSelectedClientLanguage();
    var _j = useState(null), mapRef = _j[0], setMapRef = _j[1];
    var _k = useState(false), modalVisible = _k[0], setModalVisible = _k[1];
    var _l = useState(''), modalMessage = _l[0], setModalMessage = _l[1];
    var _m = useState(''), modalUrl = _m[0], setModalUrl = _m[1];
    var _o = useState(false), showQRModal = _o[0], setShowQRModal = _o[1];
    var _p = useState(''), currentHref = _p[0], setCurrentHref = _p[1];
    useEffect(function () {
        if (projectType === ProjectType.KIOSK) {
            generateLinksForKiosk();
        }
        loadCssDesign(css_id, css_json, CONSTANTS_REQ);
    }, []);
    var generateLinksForKiosk = function () {
        var list = document.getElementsByClassName(css_id);
        for (var i = 0; i < list.length; i++) {
            var links = list[i].getElementsByTagName('a');
            var _loop_1 = function (j) {
                if (links[j].target == '_blank') {
                    links[j].removeAttribute('target');
                }
                if (links[j].href === window.location.href) {
                    return "break";
                }
                var linkValue = links[j].href;
                links[j].href = window.location.href;
                links[j].style.color = 'black';
                links[j].style.cursor = 'default';
                links[j].onclick = function showModal() {
                    setCurrentHref(linkValue);
                    setShowQRModal(true);
                };
            };
            for (var j = 0; j < links.length; j++) {
                var state_1 = _loop_1(j);
                if (state_1 === "break")
                    break;
            }
        }
    };
    var pageDetasils = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, domain, subdomain, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestGet(CONSTANTS_REQ.WEBPAGE.CLIENTGET + '/' + webPageId)];
                case 1:
                    resp = _a.sent();
                    if (resp.status === RESPONSE.OK) {
                        console.log(resp.data);
                        if (resp.data.latitude && resp.data.longitude) {
                            setLat(resp.data.latitude);
                            setLng(resp.data.longitude);
                            setZoom(13);
                        }
                        if (resp.data.project.webPublishStatus === 1) {
                            domain = resp.data.project.domain.name;
                            subdomain = resp.data.project.subdomain;
                            link = '//' +
                                (subdomain && subdomain !== '@' && subdomain !== '' ? subdomain + '.' : '') +
                                domain +
                                '/' +
                                getSelectedClientLanguage() +
                                '/' +
                                (resp.data.aliasName ? resp.data.aliasName : webPageId);
                            setWebPageQRUrl(link);
                            setStLabel(getTranslated(resp.data.name, setLang));
                        }
                        else {
                            setWebPageQRUrl('//smart-tourist.hr');
                            setStLabel(getTranslation('accomodation.qr.st', selLang));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        pageDetasils();
    }, []);
    useEffect(function () {
        setMapPosition();
    }, [zoom]);
    function setMapPosition() {
        if (mapRef) {
            mapRef.leafletElement.flyTo([lat, lng], zoom);
        }
    }
    function mapUrl() {
        return "https://www.openstreetmap.org/?mlat=" + lat + "&mlon=" + lng + "#map=" + zoom + "/" + lat + "/" + lng;
    }
    function stUrl() {
        return window.location.protocol + webPageQRUrl;
    }
    var styleA = { width: '100%', height: '100%', boxSizing: 'border-box' };
    if (jsonData.image && jsonData.image.file_path) {
        styleA.backgroundSize = 'cover';
        styleA.height = 'calc(100vw * 0.25)';
        styleA.backgroundImage = "url(" + (CONSTANTS_REQ.STATIC + projectId + encodeURI(jsonData.image.file_path)) + ")";
    }
    var blueIcon = new L.Icon({
        iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });
    return (React.createElement("section", null,
        React.createElement("div", { className: "accommodation-container", id: css_id },
            React.createElement("div", { className: "accommodation-container-content" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-8 col-md-8 col-sm-7 col-xs-12 accommodation" },
                        React.createElement("a", { style: styleA, className: "accommodation-image accommodation-img" })),
                    React.createElement("div", { className: "col-lg-4 col-md-4 col-sm-5 col-xs-12 accommodation" },
                        React.createElement(Map, { ref: function (ref) {
                                setMapRef(ref);
                            }, className: "accommodation-map", center: [lat, lng], zoom: zoom, style: { height: '100%', width: '100%' }, doubleClickZoom: false, trackResize: false, zoomControl: false, touchZoom: true, keyboard: false, gestureHandling: true, attributionControl: false, gestureHandlingOptions: {
                                text: {
                                    touch: projectInfo &&
                                        projectInfo.mapZoomText &&
                                        getTranslated(projectInfo.mapZoomText, setLang)
                                        ? getTranslated(projectInfo.mapZoomText, setLang)
                                        : 'Use two fingers to move the map',
                                    scroll: 'Use ctrl + scroll to zoom the map',
                                    scrollMac: 'Use \u2318 + scroll to zoom the map',
                                },
                            } },
                            React.createElement(TileLayer, { attribution: '\u00A9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                            React.createElement(ZoomControl, { position: "topright" }),
                            zoom > 10 && React.createElement(Marker, { icon: blueIcon, position: [lat, lng] })))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-8 col-md-8 col-sm-7 col-xs-12 accommodation-text" },
                        jsonData.title && React.createElement(HeaderTextDivider, { title: getTranslated(jsonData.title, selLang) }),
                        jsonData.image.description && (React.createElement("div", { className: "accommodation-content " + css_id },
                            React.createElement("div", { className: "extraDiv" },
                                React.createElement("div", { className: "href-link-acc contrast-color", dangerouslySetInnerHTML: {
                                        __html: getTranslated(jsonData.image.description, selLang).replace(/(<? *script)/gi, 'illegalscript'),
                                    } })))),
                        React.createElement("br", null),
                        jsonData.price && (React.createElement("div", { className: "accommodation-content" },
                            React.createElement("div", { className: "extraDiv" },
                                React.createElement("div", { className: "href-link-acc contrast-color " + css_id, dangerouslySetInnerHTML: {
                                        __html: getTranslated(jsonData.price, selLang).replace(/(<? *script)/gi, 'illegalscript'),
                                    } }))))),
                    React.createElement("div", { className: "col-lg-4 col-md-4 col-sm-5 col-xs-12 accommodation" },
                        React.createElement("div", { className: "accommodation-grayBackground" },
                            jsonData.contact && (React.createElement("div", { className: "accommodation-content thin-scrollbar " + css_id },
                                React.createElement("article", { className: "href-link-acc-right", dangerouslySetInnerHTML: {
                                        __html: getTranslated(jsonData.contact, selLang).replace(/(<? *script)/gi, 'illegalscript'),
                                    } }))),
                            React.createElement("br", null),
                            jsonData.opening && (React.createElement("div", { className: "accommodation-content" },
                                React.createElement("article", { className: "href-link-acc-right " + css_id, dangerouslySetInnerHTML: {
                                        __html: getTranslated(jsonData.opening, selLang).replace(/(<? *script)/gi, 'illegalscript'),
                                    } }))),
                            React.createElement("div", { className: "accommodation-qr-content", style: { backgroundColor: 'transparent' } },
                                React.createElement("div", { className: "accommodation-qr" },
                                    React.createElement("a", null,
                                        React.createElement("div", { className: "accommodation-qr-view" },
                                            React.createElement(QRCode, { value: mapUrl(), onClick: function () {
                                                    setModalVisible(true);
                                                    setModalUrl(mapUrl());
                                                    setModalMessage(geti18nText('accommodation.qr.map'));
                                                }, style: { padding: '20px' } }),
                                            React.createElement("div", { className: "qr_title" }, getTranslation('accomodation.qr.navigation', selLang))))),
                                React.createElement("div", { className: "accommodation-qr" },
                                    React.createElement("a", null,
                                        React.createElement("div", { className: "accommodation-qr-view" },
                                            React.createElement(QRCode, { value: stUrl(), onClick: function () {
                                                    setModalVisible(true);
                                                    setModalUrl(stUrl());
                                                    setModalMessage(geti18nText('accommodation.qr.website'));
                                                }, style: { padding: '20px' } }),
                                            React.createElement("div", { className: "qr_title" }, stLabel)))))))))),
        React.createElement("div", { className: 'accomodation-modal' + " " + (modalVisible ? 'accomodation-showModal' : '') },
            React.createElement("div", { className: "accomodation-modalContent" },
                React.createElement("span", { className: "accomodation-closeButton", onClick: function () {
                        setModalVisible(false);
                    } }, "\u00D7"),
                React.createElement(QRCode, { value: modalUrl, size: 300, style: { padding: '10px' }, onClick: function () {
                        projectType !== 'kiosk' && window.open(modalUrl, '_blank');
                    } }))),
        React.createElement("div", { className: 'imagewithtext-modal' + " " + (showQRModal ? 'imagewithtext-showModal' : '') },
            React.createElement("div", { className: "imagewithtext-modalContent" },
                React.createElement("span", { className: "imagewithtext-closeButton", onClick: function () { return setShowQRModal(false); } }, "\u00D7"),
                React.createElement(QRCode, { size: 256, value: currentHref, style: { margin: '20px 45px 0px 45px' } })))));
};
export default Accomodation;
//# sourceMappingURL=index.js.map